import { render, staticRenderFns } from "./OfficeCardNeed.vue?vue&type=template&id=61aee59d&scoped=true&"
import script from "./OfficeCardNeed.vue?vue&type=script&lang=js&"
export * from "./OfficeCardNeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61aee59d",
  null
  
)

export default component.exports